<template>
  <splash-circle
    :class="['campaign-box-splash-circle', alignment]"
    :title="title"
    :text="text"
    :bg-colour-class="bgColourClass"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SplashCircle from '@/components/UI/SplashCircle.vue';

export default defineComponent({
  name: 'CampaignBoxSplashCircle',
  components: {
    SplashCircle
  },
  props: {
    bgColourClass: {
      type: String,
      default() {
        return 'site-secondary-color';
      }
    },
    leftAlignment: {
      type: Boolean,
      default() {
        return false;
      }
    },
    title: {
      type: String,
      default() {
        return '';
      }
    },
    text: {
      type: String,
      default() {
        return '';
      }
    }
  },
  computed: {
    alignment(): string {
      return this.leftAlignment ? 'left' : 'right';
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.campaign-box-splash-circle {
  bottom: rem-calc(-30);

  &.right {
    right: rem-calc(10);
  }

  &.left {
    left: rem-calc(10);
  }

  @include breakpoint(large up) {
    width: rem-calc(200);
    height: rem-calc(200);
    bottom: rem-calc(-80);
    right: rem-calc(-50);

    &.right {
      right: rem-calc(-50);
    }

    &.left {
      left: rem-calc(-50);
    }
  }
}
</style>
